export const maxLength = (max) => (value) => {
    if (typeof value !== "string") return "Invalid input";
    return value.length <= max || `Maximum length allowed is ${max} characters`;
};
  
export const minLength = (min) => (value) => {
    if (typeof value !== "string") return "Invalid input";
    return value.length >= min || `Minimum length required is ${min} characters`;
};

// export const isNumberOnly = (value) => {
//     if (typeof value !== "string" && typeof value !== "number") return "Invalid input";
//     return /^[0-9]+$/.test(value.toString()) || "Only numeric values are allowed";
// };

  
export const isTextOnly = (value) => {
    if (typeof value !== "string" || value.trim() === "") return "This field is required";
    return /^[A-Za-z_\s]+$/.test(value) ? true : "Only alphabetic characters are allowed";
};
  

export const maxValue = (max) => (value) => {
    if (isNaN(value)) return "Invalid input";
    return parseFloat(value) <= max || `Value must be less than or equal to ${max}`;
};

export const minValue = (min) => (value) => {
    if (isNaN(value)) return "Invalid input";
    return parseFloat(value) >= min || `Value must be greater than or equal to ${min}`;
};
export const isSymbolOnly = (value) => {
    if (typeof value !== "string") return "Invalid input";
    return /^[^A-Za-z0-9\s]+$/.test(value) || "Symbols only allowed";
};

// export const isRequired = (value) => {
//     if (value === null || value === undefined || value === '') {
//         return "This field is required";
//     }
//     return true;
// };

export const isEmail = (value) => {
    if (typeof value !== "string") return "Invalid input";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value) || "Invalid email address";
};
export const isNotText = (value) => {
    if (typeof value !== "string" || value.trim() === "") return true;
    return !/^[A-Za-z\s]+$/.test(value) || "Text is not allowed";
};

export const isNotNumber = (value) => {
    if (isNaN(value)) return true;
    return "Numbers are not allowed";
};
export const maxDigit = (max) => (value) => {
    if (typeof value !== "string" && typeof value !== "number") return "Invalid input";
    const numericValue = value.toString().replace(/[^0-9]/g, "");
    return numericValue.length <= max || `Value must have at most ${max} digits`;
};

export const minDigit = (min) => (value) => {
    if (typeof value !== "string" && typeof value !== "number") return "Invalid input";
    const numericValue = value.toString().replace(/[^0-9]/g, "");
    return numericValue.length >= min || `Value must have at least ${min} digits`;
};
export const isNumberAndTextOnly = (value) => {
    if (typeof value !== "string" || value.trim() === "") return "Invalid input";
    return /^[A-Za-z0-9\s]+$/.test(value) || "Only alphanumeric characters are allowed";
};

export const isValidWebsiteURL = (value) => {
    if (typeof value !== "string" || value.trim() === "") return "Invalid input";
    return value.startsWith("https://") || "Invalid website URL";
  };

  export const isRequired = (value) => {
    if (value === null || value === undefined || value === '') {
        return "This field is required";
    }
    // Add this check for arrays
    if (Array.isArray(value) && value.length === 0) {
        return "This field is required";
    }
    return true;
};

export const isNumberOnly = (value) => {
    if (value === null || value === undefined || value === '') return true; 
    if (typeof value !== "string" && typeof value !== "number") return "Invalid input";
    return /^[0-9]+$/.test(value.toString()) || "Only numeric values are allowed";
};

export const isValidCountryCode = (value) => {
    if (typeof value !== "string" || value.trim() === "") return "Country code is required";
    return /^\+\d+$/.test(value) || "Country code must start with '+' followed by numbers only";
};

export const isFloat = (value) => {
    if (value === null || value === undefined || value === "") return "Value is required";
  
    const strValue = value.toString().trim();  // Ensure it's a string for regex
  
    if (!/^\d+(\.\d{1,2})?$/.test(strValue)) return "Only decimal numbers are allowed";
  
    return true;
  };
  

export const isNotNegative = (value) => {
    if (value === null || value === undefined || value === "") return "Value is required";
    const number = parseFloat(value);
    if (isNaN(number)) return "Value must be a number";
    if (number < 0) return "Value cannot be negative";
    return true;
};


// export const isUnique = (fieldName, existingValues, entityName = 'record', ignoreId = null) => {
//     return (value) => {
//       if (!value) return true; // Skip empty values, other validators will catch this if required
      
//       // If we're editing an existing item, ignore its own ID to allow saving unchanged values
//       const valuesToCheck = ignoreId 
//         ? existingValues.filter(item => item.id !== ignoreId)
//         : existingValues;
        
//       const isDuplicate = valuesToCheck.some(item => {
//         // Case insensitive comparison for string values
//         if (typeof value === 'string' && typeof item[fieldName] === 'string') {
//           return item[fieldName].toLowerCase() === value.toLowerCase();
//         }
//         return item[fieldName] === value;
//       });
      
//       return isDuplicate ? `This ${fieldName.replace('_', ' ')} already exists. Please use a different one.` : true;
//     };
//   };


export const isPrice = (value) => {
    if (typeof value !== "string" || value.trim() === "") return "Invalid input";
    return /^[0-9]*\.?[0-9]+$/.test(value) ? true : "Please enter a valid  amount";
};